import { render, staticRenderFns } from "./CategoryDashboardItem.vue?vue&type=template&id=f1709994&"
import script from "./CategoryDashboardItem.vue?vue&type=script&lang=js&"
export * from "./CategoryDashboardItem.vue?vue&type=script&lang=js&"
import style0 from "./CategoryDashboardItem.vue?vue&type=style&index=0&id=f1709994&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports